import { render, staticRenderFns } from "./zoneApp.vue?vue&type=template&id=bfd0f152&scoped=true&"
import script from "./zoneApp.vue?vue&type=script&lang=js&"
export * from "./zoneApp.vue?vue&type=script&lang=js&"
import style0 from "./zoneApp.vue?vue&type=style&index=0&id=bfd0f152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd0f152",
  null
  
)

export default component.exports